export const fonts = ["Bahuraksa", "circous", "circous-striped", "aloja-light","aventura","banthers","barbaro","christamstime","chubby"]